import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9e59318a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "E808D2AnswerBtnContainer bothCenter"
};
const _hoisted_2 = {
  key: 0,
  class: "mr4 ptr"
};
const _hoisted_3 = {
  key: 1,
  class: "mr4 ptr"
};
const _hoisted_4 = {
  key: 2,
  class: "mr4 ptr",
  style: {
    "transform": "rotate(90deg)"
  }
};
const _hoisted_5 = {
  key: 0,
  class: "boldFont ptr"
};
const _hoisted_6 = {
  key: 1,
  class: "boldFont mr4 ptr"
};
const _hoisted_7 = {
  key: 2,
  class: "boldFont mr4 ptr"
};
const _hoisted_8 = {
  key: 3,
  class: "boldFont ptr"
};
const _hoisted_9 = {
  key: 4
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_11 = {
  key: 5,
  class: "mr16",
  style: {
    "width": "10px",
    "height": "20px",
    "background": "red"
  }
};
const _hoisted_12 = {
  key: 6,
  class: "mr16",
  style: {
    "width": "10px",
    "height": "20px",
    "background": "green"
  }
};
const _hoisted_13 = {
  key: 7,
  style: {
    "width": "10px",
    "height": "20px",
    "background": "blue"
  }
};
const _hoisted_14 = {
  key: 8
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正确答案：", -1));
const _hoisted_19 = {
  key: 0,
  class: "mr4 ptr"
};
const _hoisted_20 = {
  key: 1,
  class: "mr4 ptr"
};
const _hoisted_21 = {
  key: 2,
  class: "mr4 ptr",
  style: {
    "transform": "rotate(90deg)"
  }
};
const _hoisted_22 = {
  key: 0,
  class: "boldFont ptr"
};
const _hoisted_23 = {
  key: 1,
  class: "boldFont mr4 ptr"
};
const _hoisted_24 = {
  key: 2,
  class: "boldFont mr4 ptr"
};
const _hoisted_25 = {
  key: 3,
  class: "boldFont ptr"
};
const _hoisted_26 = {
  key: 4
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_28 = {
  key: 5,
  class: "mr16",
  style: {
    "width": "10px",
    "height": "20px",
    "background": "red"
  }
};
const _hoisted_29 = {
  key: 6,
  class: "mr16",
  style: {
    "width": "10px",
    "height": "20px",
    "background": "green"
  }
};
const _hoisted_30 = {
  key: 7,
  style: {
    "width": "10px",
    "height": "20px",
    "background": "blue"
  }
};
const _hoisted_31 = {
  key: 8
};
const _hoisted_32 = {
  key: 0,
  style: {
    "color": "green"
  }
};
const _hoisted_33 = {
  key: 1,
  style: {
    "color": "red"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter",
    style: {
      "border-bottom": "1px solid black",
      "width": "100px"
    }
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.substring(7), (f, fi) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: f
      }, [$data.ans[0] == fi + 3 && f == 'X' ? (_openBlock(), _createElementBlock("span", _hoisted_2, "➕")) : _createCommentVNode("", true), $data.ans[0] == fi + 3 && f == 'Y' ? (_openBlock(), _createElementBlock("span", _hoisted_3, "➗")) : _createCommentVNode("", true), $data.ans[0] == fi + 3 && f == 'Z' ? (_openBlock(), _createElementBlock("span", _hoisted_4, "➗")) : _createCommentVNode("", true)], 64);
    }), 128)), $data.ans[0] == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_5, " / ")) : _createCommentVNode("", true), $data.ans[0] == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_6, " \\ ")) : _createCommentVNode("", true), $data.ans[0] == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "—")) : _createCommentVNode("", true), $data.ans[0] == 6 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "〇")) : _createCommentVNode("", true), $data.ans[0] < 0 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "?")) : _createCommentVNode("", true), _hoisted_10, $data.ans[1] == 'R' ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : $data.ans[1] == 'G' ? (_openBlock(), _createElementBlock("div", _hoisted_12)) : $data.ans[1] == 'B' ? (_openBlock(), _createElementBlock("div", _hoisted_13)) : (_openBlock(), _createElementBlock("span", _hoisted_14, "?"))]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt8"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.substring(7), (f, fi) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: fi
      }, [f == 'X' ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onClick: $event => $options.ans0(fi + 3),
        class: "mr4 ptr"
      }, "➕", 8, _hoisted_15)) : _createCommentVNode("", true), f == 'Y' ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        onClick: $event => $options.ans0(fi + 3),
        class: "mr4 ptr"
      }, "➗", 8, _hoisted_16)) : _createCommentVNode("", true), f == 'Z' ? (_openBlock(), _createElementBlock("span", {
        key: 2,
        onClick: $event => $options.ans0(fi + 3),
        class: "mr4 ptr",
        style: {
          "transform": "rotate(90deg)"
        }
      }, "➗", 8, _hoisted_17)) : _createCommentVNode("", true)], 64);
    }), 128)), _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = $event => $options.ans0(0)),
      class: "boldFont ptr"
    }, " / "), _createElementVNode("span", {
      onClick: _cache[1] || (_cache[1] = $event => $options.ans0(1)),
      class: "boldFont mr4 ptr"
    }, " \\ "), _createElementVNode("span", {
      onClick: _cache[2] || (_cache[2] = $event => $options.ans0(2)),
      class: "boldFont mr4 ptr"
    }, "—"), _createElementVNode("span", {
      onClick: _cache[3] || (_cache[3] = $event => $options.ans0(6)),
      class: "boldFont ptr"
    }, "〇️")]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt8"
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      onClick: _cache[4] || (_cache[4] = $event => $options.ans1('R')),
      class: "ptr mr16",
      style: {
        "width": "10px",
        "height": "20px",
        "background": "red"
      }
    }), _createElementVNode("div", {
      onClick: _cache[5] || (_cache[5] = $event => $options.ans1('G')),
      class: "ptr mr16",
      style: {
        "width": "10px",
        "height": "20px",
        "background": "green"
      }
    }), _createElementVNode("div", {
      onClick: _cache[6] || (_cache[6] = $event => $options.ans1('B')),
      class: "ptr",
      style: {
        "width": "10px",
        "height": "20px",
        "background": "blue"
      }
    })]),
    _: 1
  }), $props.answer ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "mt32"
  }, {
    default: _withCtx(() => [_hoisted_18, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.substring(7), (f, fi) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: f
      }, [$props.answer[0] == fi + 3 && f == 'X' ? (_openBlock(), _createElementBlock("span", _hoisted_19, "➕")) : _createCommentVNode("", true), $props.answer[0] == fi + 3 && f == 'Y' ? (_openBlock(), _createElementBlock("span", _hoisted_20, "➗")) : _createCommentVNode("", true), $props.answer[0] == fi + 3 && f == 'Z' ? (_openBlock(), _createElementBlock("span", _hoisted_21, "➗")) : _createCommentVNode("", true)], 64);
    }), 128)), $props.answer[0] == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_22, " / ")) : _createCommentVNode("", true), $props.answer[0] == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_23, " \\ ")) : _createCommentVNode("", true), $props.answer[0] == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_24, "—")) : _createCommentVNode("", true), $props.answer[0] == 6 ? (_openBlock(), _createElementBlock("span", _hoisted_25, "○️")) : _createCommentVNode("", true), $props.answer[0] < 0 ? (_openBlock(), _createElementBlock("span", _hoisted_26, "?")) : _createCommentVNode("", true), _hoisted_27, $props.answer[1] == 'R' ? (_openBlock(), _createElementBlock("div", _hoisted_28)) : $props.answer[1] == 'G' ? (_openBlock(), _createElementBlock("div", _hoisted_29)) : $props.answer[1] == 'B' ? (_openBlock(), _createElementBlock("div", _hoisted_30)) : (_openBlock(), _createElementBlock("span", _hoisted_31, "?"))]),
    _: 1
  })) : _createCommentVNode("", true), $props.answer && $props.review ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1
  }, {
    default: _withCtx(() => [$props.review.result ? (_openBlock(), _createElementBlock("span", _hoisted_32, "回答正确")) : (_openBlock(), _createElementBlock("span", _hoisted_33, "回答错误"))]),
    _: 1
  })) : _createCommentVNode("", true)]);
}